import React from "react"
import { SurfaceColor } from "@carrotfertility/carotene-core"
import { useToggle } from "#/utils/Hooks"
import { BenefitEnrollmentModule } from "#/components/views/molecules/BenefitEnrollmentModule"
import { BenefitEnrollmentFlowContainer } from "#/components/cmd-enrollment"
import { NeedsMemberUploadsModule } from "#/components/home/NeedsMemberUploadsModule"
import { useSelector } from "react-redux"
import { useReimbursements } from "#/services/user/hooks/useReimbursements"
import { ExpenseState } from "#/utils/ExpenseState"
import { useHistory } from "react-router-dom"
import BenefitsEnrollmentRequired from "#/components/home/benefits-modules/BenefitsEnrollmentRequired"
import BenefitsEnrollmentExpired from "#/components/home/benefits-modules/BenefitsEnrollmetExpired"
import Locations from "#/components/views/home/navigation"
import AvailableFundsModule from "#/components/views/molecules/AvailableFundsModule"
import { getSubsidies } from "#/redux/reducers/subsidies"

export function UnlimitedBenefitEnrollmentCardContainer({ color }: { color?: SurfaceColor }) {
  const [showUnlimitedBenefitEnrollmentModal, toggleUnlimitedBenefitEnrollmentModal] = useToggle(false)
  return (
    <>
      <BenefitEnrollmentModule onClickEnroll={toggleUnlimitedBenefitEnrollmentModal} color={color} />
      {showUnlimitedBenefitEnrollmentModal && (
        <BenefitEnrollmentFlowContainer onExit={toggleUnlimitedBenefitEnrollmentModal} />
      )}
    </>
  )
}

export function NeedsMemberUploadsCardContainer({ color }: { color?: SurfaceColor }) {
  const { data: reimbursementsList = [] } = useReimbursements()
  const expensesNeedingMemberUploads = reimbursementsList.filter(
    (expense: { expenseState: string }) => expense.expenseState === ExpenseState.NEEDS_MEMBER_UPLOADS
  )
  return (
    <NeedsMemberUploadsModule
      hasMultipleExpensesNeedingUploads={expensesNeedingMemberUploads.length > 1}
      color={color}
    />
  )
}

export function LimitedBenefitsEnrollmentRequiredCardContainer({ color }: { color?: SurfaceColor }) {
  const history = useHistory()

  return (
    <BenefitsEnrollmentRequired onClickEnroll={() => history.push(Locations.Home.EnrollmentFlowActive)} color={color} />
  )
}

export function LimitedBenefitsEnrollmentExpiredCardContainer({ color }: { color?: SurfaceColor }) {
  const history = useHistory()

  return (
    <BenefitsEnrollmentExpired onClickEnroll={() => history.push(Locations.Home.EnrollmentFlowActive)} color={color} />
  )
}

export function AvailableFundsCardContainer({ color }: { color?: SurfaceColor }) {
  const subsidies = useSelector(getSubsidies)
  const hasMultipleCategories = subsidies.length > 1
  return <AvailableFundsModule subsidies={subsidies} hasMultipleCategories={hasMultipleCategories} color={color} />
}
